import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { WiMuleSQL } from "../../services/WiMuleSQL";

const fetchIN12aTrayAmb = async () => {
  const response = await axios.get(`${WiMuleSQL}/api/BWOS/GetIN12aTrayAmbient`);

  return response.data.data;
};

export const useIN12aTrayAmbient = (enabled = true) =>
  useQuery({
    queryKey: ["IN12aTrayAmb"],
    queryFn: () => fetchIN12aTrayAmb(),
    enabled,
    staleTime: 60 * 1000, // 1 min if focused
    refetchInterval: 120 * 1000, // ← auto-update every 2 minute
  });
